import { Route } from 'react-router-dom';

export function ApplicationsMonitoringRoutes() {
    return <Route path='monitoring'></Route>;
}
